<template id="child">
  <div>
    <div v-if="showModal" :style="cssProps">
      <div class="modal d-flex flex-column">
        <h1>Select Adress</h1>
        <div class="adress-container d-flex flex-column">
            <!-- begin -->
          <div class="adress d-flex flex-row justify-content-between" v-for="(address, index) in info.savedDeliveryAddresses" :key="index" :class="choosedAddress === index ? 'active' : ''" @click="chooseAddress(index)">
            <div class="left d-flex flex-column">
              <!-- <h2>Frank Newman</h2> -->
              <span>
                {{address.streetaddress}}, {{address.building}}
              </span>
              <span>
                {{address.city}} {{address.zipcode}}
                </span>
                <span>
                {{address.phonenumber}}
              </span>
            </div>
            <div class="right d-flex align-items-start justify-content-end">
                <a href="#">Modify</a>
            </div>
          </div>
          <!-- end -->
          <div class="empty-adress d-flex align-items-center justify-content-center">
            <a href="#" @click="openModal">Add a New Delivery Address</a>
          </div>
          <div class="d-flex justify-content-center btn-cancel" @click="hide">
      <button >
        <span>Cancel</span>
      </button>
      </div>
        </div>
      </div>
      <div class="modal-overlay"></div>
      <addressmodal ref="addressmodal" @submit="saveAddress"></addressmodal>
    </div>
  </div>
</template>
   <script>
import addressModal from './addressModal.vue'
import { mapState } from "vuex";
export default {
  template: "#child",
  components: {
    addressmodal: addressModal,
  },
  data() {
    return {
      showModal: false,
      choosedAddress: null,
    };
  },
  computed: {
    ...mapState(["info"]),
    cssProps() {
      return {
        "--main-color": this.info.color ? "#" + this.info.color : "#c12d39"
      };
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    openModal(){
        this.$refs.addressmodal.show();
    },
    chooseAddress(index){
        this.choosedAddress = index;
        this.$store.commit("address.set", {index});
    },
    saveAddress(deliveryInfo){
        this.$store.commit("address.add", {address: deliveryInfo});
        this.choosedAddress = this.info.savedDeliveryAddresses.length - 1;
        this.$store.commit("address.set", {index: this.info.savedDeliveryAddresses.length - 1});
    }
  }
};
</script>
    <style scoped>
    .adress-container{
      overflow-y: auto;
      overflow-x: hidden;
      height: 100%;
    }
    button{
  border: none;
  outline: none;
  background: none;
}
.btn-cancel button
{
 margin-top: 40px;
	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;
}
.btn-cancel span{
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}
    .empty-adress a{
       
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	text-align: center;
    text-decoration: underline;

    }
    .empty-adress{
        margin-top: 8px;
        height: 132px;
  width: 334px;
  border: 1px dotted rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  background-color: #ffffff;
  min-height: 132px;

    }
    .adress{
        padding: 24px;
        margin-top: 8px;
    }
    .right a {
      
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	text-align: right;
    text-decoration: underline

    }
    
.left h2{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;

}
.left span
{
    
	width: 164px;
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
.adress {
  min-height: 132px;
  height: 132px;
  width: 334px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
}

.modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  padding: 48px;

  z-index: 5;
  overflow-y: auto;
  height: 656px;
  width: 432px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
}
.modal h1 {
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 800;
  line-height: 35px;
  text-align: center;
}

.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1;
}
.active
{
    background-color: var(--main-color) !important;
}
.active i
{
    color:#FFFFFF !important;

}
.active span
{
    color: #FFFFFF !important;
}
@media screen and (max-width: 600px){
    .modal{
        bottom: -75px;
        z-index: 11;
    }
}
</style>
    


// WEBPACK FOOTER //
// src/components/steps/modals/selectAdress.vue